import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Icon from '@mui/material/Icon';

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/operai-commesse.json"

import AlertOperai from "./alertOperai";

import GestioneOperai from "./gestioneOperai";
import Report from "./report";
import MassEdit from "./massEdit.js";
import MassDelete from "./massDelete.js";

import * as ajax from "helpers/ajax";
import { isAccordoQuadro } from "helpers/functions.js"
import { ROLES } from "constant"


export default class GestioneManodopera extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            listCommessa: [],
            listOperai:[],

            selectedCommessa: null,

            openReport: false,
            currentDate:this.props.selectedDate ? new Date(this.props.selectedDate) : new Date(),
        };

    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("commessas?populate=*", this.loadListCommessa)
        ajax.ajaxGetStrapi("operaios", this.loadListOperai)

        let id = [];
        global.workers.data.map((el) => {
            if (!el.commessa) {id.push(el.id)}
        })
        id.map((el) => {
            ajax.ajaxDeleteStrapi("operai-commesses/"+el)
        })
    }

    loadListOperai = (response) => {
        this.setState({ listOperai: response.data }, this.checkParam) 
    }

    loadListCommessa = (response) => {
        let arr = response.data;
        arr = arr.filter(item => !isAccordoQuadro(item));
        this.setState({listCommessa:arr}, this.checkParam)
    }

    checkParam = () => {
        if (this.state.listOperai.length <= 0) {return}
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let id = params.get('id');

        if (this.props.selectedCommessa) {
            id = this.props.selectedCommessa;
        }

        this.state.listCommessa.forEach((el) => {
            if (el.id == id) {
                let selectedCommessa = {
                    "label": el.nome,
                    "id": el.id
                }

                this.setState({ selectedCommessa: selectedCommessa })
                return
            }
        })

    }

    changeCommessa = (name,id) => {
        let selectedCommessa = {
            "label": name,
            "id": id
        }

        this.setState({ selectedCommessa: selectedCommessa })
    }

    listCommessaArray = () => {
        let IDUFFICIO = 52;
        let arr = [];
        this.state.listCommessa.map((el) => {
            if (el.stato == "finito") {return }
            arr.push({
                "label": el.nome,
                "id": el.id
            })
        })

        arr.sort((a, b) => a.label.localeCompare(b.label))


        arr.forEach(function (item, i) {
            if (item.id === IDUFFICIO) {
                arr.splice(i, 1);
                arr.unshift(item);
            }
        });

        return arr
    }

    openReport = () => {
        this.setState({openReport:true})
    }

    refreshWorkersData = () => {
        // Piccolo delay per assicurarsi che il server abbia completato il salvataggio
        setTimeout(() => {
            // Ricarica i dati dei worker globali prima di aggiornare i componenti
            ajax.ajaxGetStrapi("operai-commesses?populate[commessa][fields][0]=nome&populate=operaio", (response) => {
                if (response && response.data) {
                    global.workers = { data: response.data };
                    
                    // Refresh the gestione operai component
                    if (this.refGestione) {
                        this.refGestione.loadWorkingDay();
                    }
                    // Refresh the alert operai component
                    if (this.refAlert) {
                        this.refAlert.refreshData();
                    }
                }
            });
        }, 500); // Aspetta 500ms per il completamento sul server
    }

    render() {

        if (this.state.openReport) {
            return <Report data={this.state.commessaSelected} backFunction={() => this.setState({ openReport: false })} />
        }

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Gestione Manodopera"}
                    subtitle={""}
                    icon={"engineering"}
                    menu={[{ label: "Genera Report", function: this.openReport }]}
                    backButton={this.props.backFunction}
                />

                <AlertOperai 
                    ref={(ref) => this.refAlert = ref}
                    onWorkerUpdate={this.refreshWorkersData} 
                />

                <MDBox sx={{ backgroundColor: "white!important" }} p={3} mt={3} borderRadius="lg" shadow="lg" >
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={this.listCommessaArray()}
                        renderInput={(params) => <TextField {...params} label="Seleziona commessa" />}
                        value={this.state.selectedCommessa ? this.state.selectedCommessa.label : ""}
                        onChange={(event, newValue) => {
                            this.setState({ selectedCommessa: newValue })
                        }}
                    />
                </MDBox>

                {[ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo) ? null :
                this.state.listCommessa.length <= 0 || this.state.listOperai.length <= 0 ? null :
                    <Grid container>
                        <Grid item mr={1}>
                            <MassEdit
                                commesse={this.listCommessaArray()}
                                workers={this.state.listOperai}
                                reload={() => this.refGestione.loadWorkingDay()}
                            />
                        </Grid>
                        <Grid item ml={1}>
                            <MassDelete
                                commesse={this.listCommessaArray()}
                                workers={this.state.listOperai}
                                reload={() => this.refGestione.loadWorkingDay()}
                            />
                        </Grid>
                    </Grid>
                }

                {this.state.selectedCommessa ?
                    <GestioneOperai
                        setDateCallback={(val) => this.setState({ currentDate: val })}
                        selectedDate={this.state.currentDate}
                        key={this.state.selectedCommessa.id}
                        id={this.state.selectedCommessa.id}
                        operai={this.state.listOperai}
                        ref={(ref) => this.refGestione = ref}
                        changeCommessa={(name,id)=>this.changeCommessa(name,id)}
                        onWorkerUpdate={this.refreshWorkersData}
                    />
                    : null
                }
            </DashboardLayout>
        )
    }
}


